export class Message {
    _id: string;
    name: string;
    client;
    campaign: any;
    gmailId: string;
    gmailAddress: string;
    messageType: string;
    direction: string;
    sentTo: string;
    sentFrom: string;
    to: any;
    cc: any;
    bcc: any;
    subject: string;
    message: string;
    status: string;
    createdAt: Date;
    updatedAt: Date;
    dateReceived: Date; 
    created_by: any;
    user: any;
    marked: boolean;
    deleted: boolean;
    folder: string;
    isSendGrid: boolean;
    template;
    attachments;
    documents;
    anyTerm;
    hasSearchTerms;
    dateCreatedRange: any;
    dateCreated;
    dateCreatedEnd;
    sentFromName;

    // Delivery tracking (set by the Twilio/InfoBip status webhooks)
    deliveryStatus: string;
    deliveryStatusDetails: string;
    deliveredAt: Date;
    failedAt: Date;
    provider: string;

    // Normalized counterparty (last 10 phone digits for sms, lowercased address for email).
    // Threads a conversation together regardless of which record each message was filed against.
    threadKey: string;

    // ── Resolved by the sms-grid-search aggregate, not stored on the document ──
    sender: any;             // created_by on outbound, `user` on inbound — one Sender column
    counterparty: string;    // sentFrom on inbound, sentTo on outbound
    relatedRecordName: string;
    relatedRecordType: string;
    relatedRecordId: string;

    // ── SMS grid search terms ──
    owner: any;              // matches created_by OR user, so replies aren't filtered out
    messageContains: string;
    phoneContains: string;
    campaign_ids: any;
}